import { useModal } from "@danishagro/shared/src/contexts/modal.context";

export const SHOP_PICKER_MODAL_ID = "shopPicker";

// Hide prices when shop picker modal is active
export const useHidePrice = (): boolean => {
    const { activeModalId } = useModal();
    return activeModalId === SHOP_PICKER_MODAL_ID;
};
